import OrganisationPickerButton from 'Shared/components/OrganisationPicker/OrganisationPickerButton'
import OrganisationPickerSelect from 'Shared/components/OrganisationPicker/OrganisationPickerSelect'
import restClient from 'Shared/hooks/restClient'
import './OrganisationField.scoped.scss'
import Button from 'Shared/components/Button'

export default function OrganisationField({
  value,
  setFieldValue,
  disabled,
  disabledReason = null,
  allowBlank = false,
  slim = false,
  showClearButton = false,
  nullShowClientNationalName = false,
  label,
  useSelect = false,
  ...props
}) {
  const [organisationName, setOrganisationName] = useState(null)
  const [defaultOrganisation, setDefaultOrganisation] = useState(null)

  useEffect(() => {
    if (value) {
      restClient
        .get(`/api/organisations/${value}`)
        .then((data) => {
          setOrganisationName(data.data.name)
        })
    }
    restClient
      .get(`/api/organisations/national`)
      .then((data) => {
        setDefaultOrganisation(data.data)
        if (nullShowClientNationalName && !value) {
          setOrganisationName(data.data.name)
        }
      })
  }, [])

  useEffect(() => {
    if (!value) {
      setOrganisationName(nullShowClientNationalName ? defaultOrganisation?.name : null)
      return
    }
  }, [value])

  const handlePick = (id, name) => {
    setOrganisationName(name)
    setFieldValue('organisationId', id, id && id == defaultOrganisation?.id)
  }

  return (
    <div className="field">
      {label && <label>{label}</label>}
      <div className="flex gap-5">
        {(organisationName || allowBlank) && (
          useSelect ? (
            <OrganisationPickerSelect
              disabled={disabled}
              onPick={handlePick}
              title={organisationName ? `${organisationName} (Change)` : 'Choose Organisation'}
              {...props}
            />
          ) : (
            <OrganisationPickerButton
              disabled={disabled}
              onPick={handlePick}
              title={organisationName ? `${organisationName} (Change)` : 'Choose Organisation'}
              {...props}
            />
          )
        )}
        {disabledReason && <span className="smaller error margin-top">{disabledReason}</span>}
        {showClearButton && <Button small primary disabled={value == null} type="button" onClick={() => handlePick(null, null)} >{nullShowClientNationalName ? 'Clear Custom' : 'Clear'} Organisation</Button>}
      </div>
    </div>
  )
}
